<template>
    <div id="app" class="d-flex flex-column flex-root h-100vh">
        <div class="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
             id="kt_login">
            <div class="login-aside d-flex flex-column flex-row-auto" style="background-color: #ffebde;">
                <div class="d-flex flex-column-auto flex-column pt-lg-40 pt-15">
                    <a href="/" class="text-center mb-15">
                        <img src="/svg/youbuyda.svg" alt="logo" class="h-70px"/>
                    </a>
                    <div class="font-weight-bolder text-center font-size-h5 font-size-h4-lg">
                        <ul class="list-unstyled" style="line-height: 1.8em;">
                            <li><i class="fas fa-check-circle text-primary"></i>
                                {{ __('auth.list.visible') }}
                            </li>
                            <li><i class="fas fa-check-circle text-primary"></i>
                                {{ __('auth.list.brand') }}
                            </li>
                            <li><i class="fas fa-check-circle text-primary"></i>
                                {{ __('auth.list.personalize') }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-y-bottom bgi-position-x-center"
                     style="background-image: url('/assets/media/svg/illustrations/payment.svg')"></div>
            </div>
            <div class="login-content d-flex flex-column justify-content-center gap-4 gap-lg-10 p-7 mx-auto">
                <div class="d-flex flex-row justify-content-center">
                    <div class="w-md-75">
                        <h2 class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg">{{ __('auth.title') }}</h2>
                        <p class="text-muted font-size-h6" v-html="__('auth.registration_info_text')"/>
                        <p>{{ __('auth.login_info_text') }}</p>
                    </div>
                </div>

                <div class="login-form login-signin">
                    <div class="d-flex flex-row justify-content-center">
                        <div class="w-md-75">
                            <Authentication redirect-after-authentication/>
                        </div>
                    </div>
                </div>

                <div class="text-center py-4 d-flex flex-row justify-content-center w-100 gap-10">
                    <a :href="$frontendUrl() + '/agb'"
                       class="text-primary font-weight-bolder font-size-h5">{{ __('navigation.homepage.conditions_abbr') }}</a>
                    <a :href="$frontendUrl() + '/datenschutz'"
                       class="text-primary font-weight-bolder font-size-h5">{{ __('navigation.homepage.privacy') }}</a>
                    <a :href="$frontendUrl() + '/impressum'"
                       class="text-primary font-weight-bolder font-size-h5">{{ __('navigation.homepage.imprint') }}</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Authentication from '@components/Auth/Authentication.vue'
import AuthLayout from '@layouts/AuthLayout.vue';

export default {
    layout: AuthLayout,
    components: {Authentication},
    props: {
        redirectAfterAuthentication: Boolean
    },
}
</script>
